function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import TabItem from './tab-item';
import LinkContainer from './link-container';
import TabType from '../models/tab-type';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TabBar = _ref => {
  var tabs = _ref.tabs,
    tabColour = _ref.tabColour,
    tabBorderColour = _ref.tabBorderColour,
    hoverColour = _ref.hoverColour,
    tabInactiveColour = _ref.tabInactiveColour,
    tabCountColour = _ref.tabCountColour,
    onClick = _ref.onClick,
    activeIndex = _ref.activeIndex,
    tabJustification = _ref.tabJustification,
    tabAlignment = _ref.tabAlignment,
    tabGap = _ref.tabGap,
    underline = _ref.underline,
    tabWrapper = _ref.tabWrapper,
    customTabs = _ref.customTabs;
  var handleTabClick = index => {
    onClick(index, tabs[index]);
  };
  return ___EmotionJSX(LinkContainer, {
    onClick: handleTabClick,
    activeClass: "is-active",
    activeLink: activeIndex,
    tabAlignment: tabAlignment,
    tabJustification: tabJustification,
    wrapperElement: tabWrapper,
    tabGap: tabGap,
    underline: underline
  }, tabs.map(tab => tab ? ___EmotionJSX(TabItem, _extends({
    key: tab.id
  }, tab, {
    tabColour: tabColour,
    tabBorderColour: tabBorderColour,
    hoverColour: hoverColour,
    tabInactiveColour: tabInactiveColour,
    tabCountColour: tabCountColour
  })) : null), customTabs);
};
TabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape(TabType)).isRequired,
  tabWrapper: PropTypes.element,
  tabJustification: PropTypes.oneOf(['left', 'right', 'full', 'auto']).isRequired,
  tabAlignment: PropTypes.oneOf(['left', 'centre']).isRequired,
  tabGap: PropTypes.oneOf(['default', 'big']).isRequired,
  underline: PropTypes.bool.isRequired,
  tabColour: PropTypes.string,
  tabBorderColour: PropTypes.string,
  tabInactiveColour: PropTypes.string,
  tabCountColour: PropTypes.string,
  activeIndex: PropTypes.number,
  className: PropTypes.string,
  type: PropTypes.oneOf(['js', 'css']),
  hoverColour: PropTypes.string,
  customTabs: PropTypes.arrayOf(PropTypes.node),
  onClick: PropTypes.func
};
TabBar.defaultProps = {
  activeIndex: 0,
  tabWrapper: undefined,
  tabColour: undefined,
  tabBorderColour: undefined,
  tabCountColour: undefined,
  tabInactiveColour: undefined,
  className: null,
  type: 'js',
  hoverColour: undefined,
  customTabs: [],
  onClick: () => {}
};
export default TabBar;